/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '../../actions.constants';
import { storeMutations } from '../../mutations.constants';

const userActions = {
  [storeActions.addHtmlContent]: ({ commit }, payLoad) => {
    return httpClient.post(`/config/create/${payLoad.id}`, payLoad).then(
      (res) => {
        commit(storeMutations.HtmlContentSaveMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.HtmlContentSaveMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.GetHTMLContent]: ({ commit }, payLoad) => {
  
    return httpClient
      .get(`/config/getRegisterPageData/${payLoad.id}`)
      .then(
        (res) => {
         // commit(storeMutations.HtmlContentMutation, res);
          return res;
        },
        (err) => {
        //  commit(storeMutations.HtmlContentMutation, err);
          return err.response;
        },
      );
  },
  [storeActions.getDynamicUrls]: ({ commit }, id) => {
    return httpClient
      .get(`/config/getDynamicUrls/`+id)
      .then(
        (res) => {
          // commit(storeMutations.licenseMutation, res);
          return res;
        },
        (err) => {
          // commit(storeMutations.licenseMutation, err);
          return err.response;
        },
      );
  },
  [storeActions.createEndPoints]: ({ commit }, payLoad) => {
    return httpClient.post('/config/createEndPoints', payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.uploadImage]: ({commit}, payLoad ) => {
    const formData = new FormData()
    formData.append('file',payLoad.file)
    return httpClient.postWithFormData('/config/uploadImage', formData).then(
      (res) => {
        return res;
      },
      (err) => {
        return err.response;
      },
    );
  },
  [storeActions.getSignupData]: ({ commit }, {payLoad,page,limit}) => {
    let url=`/metrics/dashboard/signup`
    if(page) url +=`?page=${page}&limit=${limit}`
    return httpClient.post(url, payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getDirectSignups]: ({ commit }, {payLoad,page,limit}) => {
    let url=`/metrics/dashboard/directSignup`
    return httpClient.post(url, payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getEarlyChurnRate]: ({ commit }, {payLoad,page,limit}) => {
    let url=`/metrics/dashboard/earlyChurnRate`
    if(page) url +=`?page=${page}&limit=${limit}`
  
    return httpClient.post(url, payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getPaidConversionRate]: ({ commit }, {payLoad,page,limit}) => {
    let url=`/metrics/dashboard/paidConversionRate`
    return httpClient.post(url, payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getAvgUsers]: ({ commit }, {payLoad,page,limit}) => {
    let url=`/metrics/dashboard/avgUsers`
   
    return httpClient.post(url, payLoad).then(
      (res) => {
        // commit(storeMutations.licenseMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.licenseMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getInvitedUsersCount]: ({ commit }) => { 
    
    return httpClient.get(`/customer/customerUniqCount`).then(
      (res) => {
        // commit(storeMutations.setCustomerProjectsByIdInfo, res);
        return res;
      },
      (err) => {
        //  commit(storeMutations.setCustomerProjectsByIdInfo, err);
        return err.response;
      },
    );
  },
  
  
};
export default { ...userActions };
